import React from "react";

const Description = props => {
  return (
    <div>
      <p>
        {"TODO: write short description about the dataset and this dataviz"}
      </p>
    </div>
  );
};

export default Description;



// WEBPACK FOOTER //
// ./src/components/Description.js